import { render, staticRenderFns } from "./ViewCompanyContact.vue?vue&type=template&id=c9a08348"
import script from "./ViewCompanyContact.vue?vue&type=script&lang=js"
export * from "./ViewCompanyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports